<div class="notes-container">
  <!-- Loading notes - Show skeletons -->
  @if (isLoadingNotes$ | async) {
    <ion-list class="list" no-padding>
      @for (item of [0,1,2]; track item) {
        <ion-item class="list-item list-item--todo-item" lines="full">
          <ion-chip class="chip" slot="start" outline color="dark">
            <ion-label class="chip__label">
              <ion-skeleton-text animated style="min-width: 70px;"></ion-skeleton-text>
            </ion-label>
          </ion-chip>
          <ion-label>
            <h3 class="list-item__title list-item__title--ellipsis">
              <ion-skeleton-text animated style="width: 90%;"></ion-skeleton-text>
            </h3>
            <h4 class="list-item__subtitle">
              <ion-chip class="inline-avatar">
                <ion-avatar class="avatar">
                  <span class="avatar__initials">
                    <ion-skeleton-text animated style="min-width: 20px;"></ion-skeleton-text>
                  </span>
                </ion-avatar>
                <ion-label class="avatar__label">
                  <ion-skeleton-text animated style="width: 40%;"></ion-skeleton-text>
                </ion-label>
              </ion-chip>
            </h4>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  <!-- Notes are loaded. Show real content -->
  @if (!(isLoadingNotes$ | async)) {
    <ion-list class="list" no-padding>
      <!-- zero state when there are no notes -->
      @if (allNotes?.length === 0) {
        <ion-item class="list-item list-item--zero-state" lines="none" text-wrap>
          <span class="zero-state zero-state__title" [innerHtml]="zeroStateText"></span>
        </ion-item>
      }
      <!-- has notes state -->
      @if (count > 0) {
        <div>
          @for (note of allNotes; track trackByNoteId($index, note)) {
            <ion-item class="list-item" lines="full" (click)="presentNotesMenuForEdit(note.id)">
              <div class='content-wrapper'>
                <div class='content-wrapper-item'>
                  @if (editMode) {
                    <ion-checkbox (ionChange)="toggleSelected($event, note)" class="checkbox" slot="start">
                    </ion-checkbox>
                  }
                  @if (note.type === 'todo') {
                    <ion-chip class="todo-chip"
                      [ngClass]="{ 'todo-chip--no-due-date': !note.dueDateISO }" slot="start" outline color="dark">
                      <div class="todo-chip-label">
                        <div class="todo-chip-label__title">
                          {{ 'notes-page.todo-chip.title' | translate }}
                        </div>
                        <div class="todo-chip-label__date">
                          <span class="todo-chip-label__due">
                            {{ 'notes-page.todo-chip.date' | translate }}
                          </span>
                          <span>{{ note.dueDateISO | date: 'MM/dd' }}</span>
                        </div>
                      </div>
                    </ion-chip>
                  }
                  <ion-label class="list-item__label">
                    <h3 class="list-item__title">
                      <ion-button class="list-item-label__button"
                        fill="clear" [title]="'notes-page.editNote' | translate">
                        {{ note.body }}
                      </ion-button>
                    </h3>
                    @if (note.students.length > 0) {
                      <h4 class="list-item__subtitle">
                        @if (note.students.length > 2) {
                          <ion-button (click)="showStudents()"
                            class="content-expandable__button action-button action-button--link"
                            [ngClass]="{ 'content-expandable__button--expanded': isExpanded }"
                            [title]="'notes-page.show-all-students' | translate">
                            <div class="action-button__icon label-icon icon-chevron" slot="end" aria-hidden="true">
                            </div>
                            <ion-label class="action-button__label">{{ note.students.length }} Students
                            </ion-label>
                          </ion-button>
                        }
                        <span class="content-expandable"
                          [ngClass]="{ 'content-expandable--collapsed': !isExpanded && note.students.length > 2 }">
                          @for (student of note.students; track student) {
                            <ion-chip class="inline-avatar">
                              <ion-avatar class="avatar">
                                <span class="avatar__initials">{{ student.initials }}</span>
                              </ion-avatar>
                              <ion-label class="avatar__label">{{ student.name }}</ion-label>
                            </ion-chip>
                          }
                        </span>
                      </h4>
                    }
                  </ion-label>
                </div>
                <ion-note class="list-item__info" slot="end" color="default">
                  {{ note.updatedDate | date: 'MM/dd' }}
                </ion-note>
              </div>
            </ion-item>
          }
        </div>
      }
    </ion-list>
  }
</div>
